var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('oct-file-selector',{attrs:{"image":_vm.$_octUploader_image,"multiple":_vm.multiple,"size":_vm.size,"type":_vm.type},on:{"update:image":function($event){_vm.$_octUploader_image=$event},"change":_vm.upload}})}
var staticRenderFns = []

export { render, staticRenderFns }